import { ElementRef, inject } from '@angular/core';

import { Observable } from 'rxjs';

export const withIntersectionObserver = (
  opts?: IntersectionObserverInit,
): Observable<IntersectionObserverEntry> => {
  const el = inject(ElementRef).nativeElement;
  return new Observable(observer => {
    const intersectionObsever = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        observer.next(entry);
      });
    }, opts);
    intersectionObsever.observe(el);
    return () => intersectionObsever.unobserve(el);
  });
};
